<template>
  <mastery-footer class="attachment-footer">
    <template #before-action>
      <button
        class="more-info-button"
        :class="{ open: showMoreInfo }"
        @click="toggleMoreInfo"
      >
        <icon
          class="dots-icon"
          name="dots"
        />
      </button>
      <div
        v-if="showMoreInfo"
        class="more-info"
      >
        <p class="title option">
          Improve the app
        </p>
        <a
          v-if="!!suggestATopicUrl"
          :href="suggestATopicUrl"
          target="_blank"
          rel="noopener"
          class="suggest option"
        >
          Suggest a related topic
        </a>
      </div>
      <bookmark-button
        v-if="showBookmark"
        :asset-name="attachment.assetTitle"
        :bookmarkable-type="'Attachment'"
        :bookmarkable-id="attachment.id"
        :context-id="category && category.id"
      />
      <div
        v-if="showNavigation"
        class="nav-buttons"
        data-test="navigation-buttons"
      >
        <button
          v-show="previousAttachment"
          class="previous"
          data-test="previous-button"
          @click="previous"
        >
          <span class="icon"><icon name="arrow-left" /></span>
          <span class="text">Previous</span>
        </button>
        <button
          class="next"
          data-test="next-button"
          @click="next"
        >
          <span class="text">{{ nextText }}</span>
          <span class="icon"><icon name="arrow-right" /></span>
        </button>
      </div>
    </template>
  </mastery-footer>
</template>

<script>
import Icon from '@components/singletons/icon.vue';
import BookmarkButton from '@components/singletons/bookmarkButton.vue';
import MasteryFooter from '@components/mastery/footer.vue';
import GlobalMixin from '@/mixins/global';

export default {
  components: { Icon, BookmarkButton, MasteryFooter },
  mixins: [GlobalMixin],
  props: {
    attachment: {
      type: Object,
    },
    category: {
      type: Object,
    },
    nextAttachment: {
      type: Object,
    },
    previousAttachment: {
      type: Object,
    },
    showBookmark: {
      type: Boolean,
      default: true,
    },
    showNavigation: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['gotoAttachment', 'done'],
  data() {
    return {
      showMoreInfo: false,
    };
  },
  computed: {
    isMasteryApp() {
      return this.$store.getters['app/isMasteryApp'];
    },
    suggestATopicUrl() {
      const pv = this.$store.getters['productVars/get']['suggestURL'];
      return pv?.value;
    },
    nextText() {
      return this.nextAttachment ? 'Next' : 'Done';
    },
  },
  methods: {
    toggleMoreInfo() {
      this.showMoreInfo = !this.showMoreInfo;
    },
    next() {
      if (this.nextAttachment) {
        return this.$emit('gotoAttachment', this.nextAttachment);
      } else {
        return this.$emit('done');
      }
    },
    previous() {
      if (this.previousAttachment) {
        return this.$emit('gotoAttachment', this.previousAttachment);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-footer {
  align-items: center;
  flex-direction: row;

  .more-info-button {
    background: transparent;
    border-radius: 8px;
    height: rem-calc(24);
    margin: 0 8px;
    padding: 3px;
    width: rem-calc(24);

    &.open {
      background-color: #e4e4e4;
    }
  }

  &.mastery {
    left: rem-calc(88);

    .more-info-button {
      margin-left:48px;
    }
  }

  @include breakpoint(small) {
    left: 0;
    padding: 0 rem-calc(16);

    &.mastery {
      left: 0;
      bottom: rem-calc(72);

      .more-info-button {
        margin-left: 16px;
      }
    }
  }

  .more-info {
    @include shadowed;
    background: #ffffff;
    border-radius: 8px;
    left: 16px;
    position: absolute;
    text-align: center;
    bottom: 60px;
    width: rem-calc(232);

    .option {
      background: transparent;
      border-bottom: 1px solid #e4e4e4;
      color: inherit;
      display: block;
      margin: 0;
      padding: 12px 0;
      text-decoration: none;
      width: 100%;

      &:last-child {
        border-color: transparent;
      }
    }

    .title {
      color: #767676;
      font-size: rem-calc(12);
      font-weight: $bold;
    }

    .improve {
      color: #dc3416;
    }
  }
}

  .nav-buttons {
    display: flex;
    width: 100%;
    max-width: rem-calc(700);
    margin: auto;
    margin-left: rem-calc(30);

    .previous, .next {
      align-items: center;
      background: $grey-5;
      border: solid 1px #dfe3e9;
      border-radius: 4px;
      box-sizing: border-box;
      color: #354052;
      display: flex;
      justify-content: center;
      font-size: rem-calc(12);
      font-weight: $semi-bold;
      height: rem-calc(30);
      padding: rem-calc(4) rem-calc(8);
      width: rem-calc(100);

      .icon {
        width: rem-calc(16);
        color: #354052;
        position: relative;
        top: 1px;
      }

      .text {
        font-size: rem-calc(14);
        color: #354052;
      }
    }

    .next .text {
      margin-right: rem-calc(4);
    }

    .previous {
      margin-right: rem-calc(16);

      @include breakpoint(medium) {
        margin-left: rem-calc(16)
      }

      &.inactive {
        cursor: not-allowed;
        opacity: 0.6;
        pointer-events: none;
      }

      .text {
        margin-left: rem-calc(4);
      }
    }
  }

</style>
